<template>
        <BreadCrumb PageTitle=" Liste des places" />

    <ListePlace/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";

 import ListePlace from "@/components/Place/ListePlace.vue";

    export default defineComponent({
      name: "ListePlacePage",
      components: {
        BreadCrumb,
        ListePlace,
      },
    });
  </script>